<div class="container-fluid pad">
    <div class="row mobView">
        <!-- Header -->
        <div class="col-md-12 col-12 col-sm-12 pad0 padHeder"  style="padding-bottom: 0px;">
            <span style="font-size: 22px; margin-right: 10px; cursor: pointer;" class="mobView" (click)="goBack();"><i class="fa fa-chevron-left"></i></span>
            <h4 style="display: inline-block;">Product Units </h4> 
            <span style="font-size: 22px; margin-right: 10px; cursor: pointer; float: right; display: none;" class="webView closeMdl" (click)="goBack();">
                <i class="zmdi zmdi-close"></i>
            </span>
            
        </div>

        <!-- Body -->
        <div class="col-md-12 col-sm-12 col-12 DivPad">
            <div class="col-md-12 col-12 col-sm-12" style="padding-top: 10px; padding-left: 15px; margin-bottom: 5px;">
                <div class="col-md-12 col-12 col-sm-12" style="font-size: 22px; padding-left: 0px;">
                    <span style="color: #E88421;">
                        <i class="zmdi zmdi-widgets"></i> {{prductUnitData.productName}}
                    </span>  
                </div>
            </div>
            <div class="col-md-12 col-12 col-sm-12" style="padding-top: 10px; margin-top: 10px; 
                padding-left: 15px; margin-bottom: 5px; background-color: #e8842108; padding-bottom: 15px;">
                <div style="color: #E88421; font-size: 19px;">
                    <span>Primary Unit</span>
                </div>
                <div style="margin-top: 8px;">
                    <div class="col-md-6 col-12 col-sm-12" style="font-size: 12px; color: #777;">
                        <select class="form-control" style="background-color: inherit; padding-left: 0px;"
                        (change)="changeSKU();" [(ngModel)]="prductUnitData.primaryUnitID">
                            <option value="0">-- Select Unit --</option>
                            <option value="{{u.UID}}" *ngFor="let u of unitList">{{u.UNm}}</option>
                        </select>
                    </div>
                </div>
            </div>

            <!-- Secondary Unit -->
            <div class="col-md-12 col-12 col-sm-12" style="background-color: #DAA52008; padding-top: 10px; 
            padding-bottom: 15px; margin-top: 10px;">
                <div style="color: #DAA520; font-size: 19px;">
                <span>Secondary Unit</span>
                </div>

                <div style="margin-top: 8px;">
                    <div class="col-md-12 col-12 col-sm-12" style="font-size: 15px; color: #777;">
                        <div *ngFor="let u of selectedUnits">
                            <span>1 </span> 
                            <span>{{u.UNm}}</span>
                            <span style="padding: 10px;"> = </span>
                            <span>{{u.Rto}} </span>
                            <span>{{prductUnitData.primaryUnitName}}</span>
                            
                        </div>
                    
                    </div>
                </div>

                <div style="margin-top: 8px;">
                    <div class="col-md-12 col-12 col-sm-12" style="font-size: 15px; color: #777;">
                        <span>1 </span>
                        <select class="form-control" [(ngModel)]="secondaryPrdUnit.unitID" style="background-color: inherit; padding-left: 0px; display: inline-block; width: 35%;">
                            <option value="0">-- Select Unit --</option>
                            <option value="{{u.UID}}" *ngFor="let u of unitList">{{u.UNm}}</option>
                        </select>
                        <span style="padding: 15px;"> = </span>
                        <input type="text" class="form-control" (blur)="fn_changeSecQty();" 
                            [(ngModel)]="secondaryPrdUnit.ratio" (change)="fn_ChangeUnitRatio($event)"
                        style="display: inline-block; width: 35%; text-align: right; background-color: inherit;">
                        <span>{{prductUnitData.primaryUnitName}}</span>
                    </div>               
                </div>
            </div>

            <!-- Save Unit -->
            <div class="col-md-12 col-12 col-sm-12 bgWhite" style="padding-top: 5px; margin-top: 10px;">
                <div class="btn btn-green" (click)="fn_saveProductUnit();">
                    <i class="zmdi zmdi-check"></i> Save
                </div>
            </div>
        </div>
    </div>

    <div class="row webView" style="padding: 20px;">
        <div style="color: #555; font-size: 19px;">
            <span style="font-size: 1.4rem;;">Product Units</span>
            <span class="closeMdl" style="position: absolute; right: 15px; top: 15px; padding: 2px 10px !important;" (click)="goBack()">
                <i class="zmdi zmdi-close"></i>
            </span>
        </div>

        <!-- Body -->
        <div class="col-md-12 col-sm-12 col-12 DivPad" style="margin-bottom: 0px;">
            <div class="col-md-12 col-12 col-sm-12" style="padding-top: 10px; margin-top: 10px; 
                padding-left: 15px; margin-bottom: 5px; background-color: #00808008; padding-bottom: 15px;">
                <div style="color: #008080; font-size: 16px;">
                    <span>Primary Unit</span>
                </div>
                <div style="margin-top: 8px;">
                    <div class="col-md-6 col-12 col-sm-12" *ngIf="xnIDs == ''" style="font-size: 12px; color: #777;">
                        <select class="form-control" style="background-color: inherit; padding-left: 0px;"
                        (change)="changeSKU();" [(ngModel)]="prductUnitData.primaryUnitID">
                            <option value="0">-- Select Unit --</option>
                            <option value="{{u.UID}}" *ngFor="let u of unitList">{{u.UNm}}</option>
                        </select>
                    </div>
                    <div class="col-md-6 col-12 col-sm-12" *ngIf="xnIDs != ''" style="font-size: 14px; padding: 0px; color: #777;">
                        {{prductUnitData.primaryUnitName}}
                    </div>
                </div>
            </div>

            <!-- Secondary Unit -->
            <div class="col-md-12 col-12 col-sm-12" style="background-color: #1f628e08; padding-top: 10px; 
            padding-bottom: 15px; margin-top: 10px;">
                <div style="color: #1f628e; font-size: 16px;">
                <span>Secondary Unit</span>
                </div>

                <div style="margin-top: 8px;">
                    <div class="col-md-12 col-12 col-sm-12" style="font-size: 13px; color: #777; padding: 0px;">
                        <div *ngFor="let u of selectedUnits; let i = index" style="margin: 5px 0px;">
                            <span>
                            <span>1 </span> 
                            <span>{{u.UNm}}</span>
                            <span style="padding: 10px;"> = </span>
                            <span>{{u.Rto}} </span>
                            <span>{{prductUnitData.primaryUnitName}}</span>
                            <span class="lableBtnGray inLneBlk" (click)="deleteUnit(i)" style="border-radius: 10px; margin-left: 10px; font-size: 14px; padding: 1px 7px 1px;"><i class="fa fa-trash"></i></span>
                        </span>
                        </div>
                    
                    </div>
                </div>

                <div style="margin-top: 8px;">
                    <div class="col-md-12 col-12 col-sm-12" style="font-size: 13px; color: #777;">
                        <span>1 </span>
                        <select class="form-control" [(ngModel)]="secondaryPrdUnit.unitID" style="background-color: inherit; padding-left: 0px; display: inline-block; width: 35%;font-size: 13px;">
                            <option value="0">-- Select Unit --</option>
                            <option value="{{u.UID}}" *ngFor="let u of unitList">{{u.UNm}}</option>
                        </select>
                        <span style="padding: 15px;"> = </span>
                        <input type="text" class="form-control" (blur)="fn_changeSecQty();" 
                            [(ngModel)]="secondaryPrdUnit.ratio" (change)="fn_ChangeUnitRatio($event)"
                        style="display: inline-block; width: 35%; text-align: right; background-color: inherit;">
                        <span>{{prductUnitData.primaryUnitName}}</span>
                    </div>               
                </div>
            </div>

            <!-- Save Unit -->
            <div class="col-md-12 col-12 col-sm-12 bgWhite" style="padding-top: 5px; margin-top: 10px; padding-left: 0px;">
                <div class="btn btn-green" (click)="fn_saveProductUnit();" style="padding: 0px 10px;line-height: 30px;font-size: 14px;">
                    <i class="zmdi zmdi-check"></i> Save
                </div>
            </div>
        </div>
    </div>
</div>